<template>
    <button class="cursor-pointer rounded-lg border-2 border-gray-200 p-2" :class="colorClasses" @click="handleClick()">
        <span class="text-3xl">{{ answerOption.value }}</span>
    </button>
</template>
<script setup lang="ts">
    import { EmployeeFeedbackAnswerColor, EmployeeFeedbackAnswerOptionDto } from "@/services/api/services";
    import { computed } from "vue";

    const props = defineProps<{
        answerOption: EmployeeFeedbackAnswerOptionDto;
        hasAnswerBeenSelected: boolean;
        selected: boolean;
    }>();

    const emit = defineEmits(["click"]);

    function handleClick() {
        emit("click", props.answerOption);
    }

    const colorClasses = computed(() => {
        if (props.selected) {
            return "bg-primary border-primary";
        }
        if (props.hasAnswerBeenSelected) {
            return "";
        }
        switch (props.answerOption.bgColor) {
            case EmployeeFeedbackAnswerColor.red:
                return "bg-red-500";
            case EmployeeFeedbackAnswerColor.orange:
                return "bg-orange-500";
            case EmployeeFeedbackAnswerColor.yellow:
                return "bg-yellow-500";
            case EmployeeFeedbackAnswerColor.lightgreen:
                return "bg-lime-600";
            case EmployeeFeedbackAnswerColor.green:
                return "bg-green-700";
            default:
                return "";
        }
    });
</script>
